export const RATING_TONE_STOPS = [
   "var(--rating-tone-1)",
   "var(--rating-tone-2)",
   "var(--rating-tone-3)",
   "var(--rating-tone-4)",
   "var(--rating-tone-5)",
];

export const RATING_WORST = RATING_TONE_STOPS[0];
export const RATING_BEST = RATING_TONE_STOPS[4];
export const RATING_SURFACE = "var(--black-p)";

function getRatingBlend(value) {
   const numeric = Number(value);
   if (!Number.isFinite(numeric) || numeric <= 0) return null;

   const clamped = Math.max(1, Math.min(5, numeric));
   const lowIndex = Math.floor(clamped) - 1;
   const highIndex = Math.min(RATING_TONE_STOPS.length - 1, lowIndex + 1);
   const mix = clamped - Math.floor(clamped);

   return { clamped, lowIndex, highIndex, mix };
}

export function getRatingAccentColor(value) {
   const blend = getRatingBlend(value);
   if (!blend) return null;

   const toneA = RATING_TONE_STOPS[blend.lowIndex];
   const toneB = RATING_TONE_STOPS[blend.highIndex];
   if (blend.mix === 0 || blend.lowIndex === blend.highIndex) return toneA;

   const toneAPercent = Math.round((1 - blend.mix) * 100);
   return `color-mix(in srgb, ${toneA} ${toneAPercent}%, ${toneB})`;
}

function buildRatingSurfaceGradient(value, accentWeightVar) {
   const accent = getRatingAccentColor(value);
   if (!accent) return undefined;

   const edge = `color-mix(in srgb, ${accent} var(${accentWeightVar}, 38%), ${RATING_SURFACE})`;

   return {
      "--rating-accent": accent,
      background: `linear-gradient(to left, ${RATING_SURFACE}, ${edge})`,
   };
}

export function getRatingCardStyle(value) {
   return buildRatingSurfaceGradient(value, "--rating-card-accent-weight");
}

export function getRatingCardStyleSoft(value) {
   return buildRatingSurfaceGradient(value, "--rating-card-accent-weight-soft");
}

export function getTrendBarFill(average) {
   return getRatingAccentColor(average);
}

export function getRatingPalette(value) {
   const accent = getRatingAccentColor(value);
   if (!accent) return null;

   return {
      accent,
      cardStyle: getRatingCardStyle(value),
   };
}

/** @deprecated use getRatingAccentColor */
export function getStarToneForAverage(average) {
   const value = Number(average);
   if (!Number.isFinite(value) || value <= 0) return 0;

   const low = Math.floor(value);
   const fraction = value - low;
   if (fraction >= 0.35 && low < 5) return low + 1;
   return Math.max(1, low);
}

/** @deprecated use getRatingCardStyle */
export function getAverageCardStyle(average) {
   return getRatingCardStyle(average);
}

/** @deprecated use getRatingAccentColor */
export function getAverageValueColor(average) {
   return getRatingAccentColor(average);
}
